export const SET_SELECTED = 'NM SET SELECTED';
export const SET_LEVEL = 'NM SET LEVEL';
export const SET_STACK = 'NM SET STACK';
export const REMOVE_NUMBER = 'NM REMOVE ITEM';
export const PAUSE = 'NM PAUSE';
export const SET_SECS = 'NM SET SECS';
export const SET_SCORE = 'NM SET SCORE';
export const SET_OVER = 'NM SET OVER';
export const UPDATE_STATS = 'NM UPDATE STATS';
export const SET_POINTS = 'NM SET POINTS';
export const SET_POINTS_VISIBLE = 'NM SET POINTS VISIBLE';
export const SET_PRACTICE = 'NM SET PRACTICE';
export const SET_INIT = 'NM SET INIT';

export const setSelected = numbers => ({ type: SET_SELECTED, numbers });
export const setLevel = level => ({ type: SET_LEVEL, level });
export const setStack = stack => ({ type: SET_STACK, stack });
export const removeNumber = num => ({ type: REMOVE_NUMBER, num });
export const pause = on => ({ type: PAUSE, on });
export const setSecs = secs => ({ type: SET_SECS, secs });
export const setScore = score => ({ type: SET_SCORE, score });
export const setOver = on => ({ type: SET_OVER, over: on });
export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setPoints = points => ({ type: SET_POINTS, points });
export const setPointsVisible = pointsVisible => ({ type: SET_POINTS_VISIBLE, pointsVisible });
export const setPractice = on => ({ type: SET_PRACTICE, on });
export const setInit = on => ({ type: SET_INIT, on });
